module.exports = __webpack_public_path__ + "static/media/disney.21b0866c.png";